import { render } from "./RiskProfile.vue?vue&type=template&id=5ba05eec"
import script from "./RiskProfile.vue?vue&type=script&lang=js"
export * from "./RiskProfile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__